export const _en = {
    addProductModelButton: {
        label: "Add product model",
        tooltip: "Add product model"
    },
    dialog: {
        add: {
            title: "Add model",
            buttons: {
                save: "Save",
                cancel: "Discard"
            }
        }
    },
    sidebar: {
        back: "Back",
        form: "Globals information",
        teaching: "Training program"
    },
    teaching: {
        addButton: {
            label: "Day"
        },
        accordions: {
            attributes: {
                header: "Attributes"
            },
            prerequisites: {
                header: "Prerequisites"
            },
            resources: {
                header: "Needed resources",
                resourceTypeSelect: {
                    label: "Resource types"
                },
                resourceTypeBlock: {
                    inputLabel: "Resources number"
                }
            }
        },
        creationDefaultValue: {
            defaultDay: {
                label: "Day "
            }
        },
        smartSelect: {
            emptyValue: {
                label: "No value"
            }
        }
    },
    activities: {
        addActivityButton: {
            label: "Add activity"
        },
        dialog: {
            edit: {
                title: "Edit activity"
            },
            delete: {
                title: "Delete activity"
            },
            add: {
                title: "Add activity"
            }
        },
        tooltip: {
            up: "Up",
            down: "Down"
        }
    },
    module: {
        add: {
            title: "Add module"
        },
        edit: {
            title: "Edit module"
        },
        delete: {
            title: "Delete module"
        },
        tooltip: {
            add: "Add",
            delete: "Delete",
            up: "Up",
            down: "Down"
        }
    },
    propertyLAbel: {
        afca: {
            label: "Prefix"
        },
        ato: {
            label: "Stage code"
        }
    },
    dayOfWeek: {
        monday: {
            label: "Monday"
        },
        tuesday: {
            label: "Tuesday"
        },
        wednesday: {
            label: "Wednesday"
        },
        thursday: {
            label: "Thursday"
        },
        friday: {
            label: "Friday"
        },
        saturday: {
            label: "Saturday"
        },
        sunday: {
            label: "Sunday"
        }
    },
    timeOptions: {
        month: {
            label: "Month"
        },
        weeks: {
            label: "Week"
        },
        days: {
            label: "Day"
        },
        years: {
            label: "Year"
        }
    }

};


export const _fr = {
    addProductModelButton: {
        label: "Modèle de stage",
        tooltip: "Créer un modèle de stage"
    },
    dialog: {
        add: {
            title: "Ajout d'un modèle",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    },
    sidebar: {
        back: "Retour",
        form: "Informations générales",
        teaching: "Programme pédagogique"
    },
    teaching: {
        addButton: {
            label: "Jour"
        },
        accordions: {
            attributes: {
                header: "Attributs"
            },
            prerequisites: {
                header: "Prérequis"
            },
            resources: {
                header: "Affectation des besoins en ressources",
                resourceTypeSelect: {
                    label: "Types de ressources"
                },
                resourceTypeBlock: {
                    inputLabel: "Nombre de ressources"
                }
            }
        },
        creationDefaultValue: {
            defaultDay: {
                label: "Jour"
            }
        },
        smartSelect: {
            emptyValue: {
                label: "Pas de valeur"
            }
        }
    },
    activities: {
        addActivityButton: {
            label: "Activité"
        },
        dialog: {
            edit: {
                title: "Édition d'une activité"
            },
            delete: {
                title: "Supprimer une activité"
            },
            add: {
                title: "Ajout d'une activité"
            },
            duplicate: {
                title: "Duplication d'une activité"
            }
        },
        tooltip: {
            up: "Monter",
            down: "Descendre"
        }
    },
    module: {
        add: {
            title: "Ajout d'une journée"
        },
        edit: {
            title: "Édition d'une journée"
        },
        delete: {
            title: "Supprimer une journée"
        },
        duplicate: {
            title: "Duplication d'une journée"
        },
        tooltip: {
            add: "Ajouter",
            delete: "Supprimer",
            up: "Monter",
            down: "Descendre"
        }
    },
    propertyLAbel: {
        afca: {
            label: "Préfixe"
        },
        ato: {
            label: "Code de stage"
        }
    },
    dayOfWeek: {
        monday: {
            label: "Lundi"
        },
        tuesday: {
            label: "Mardi"
        },
        wednesday: {
            label: "Mercredi"
        },
        thursday: {
            label: "Jeudi"
        },
        friday: {
            label: "Vendredi"
        },
        saturday: {
            label: "Samedi"
        },
        sunday: {
            label: "Dimanche"
        }
    },
    timeOptions: {
        month: {
            label: "Mois"
        },
        weeks: {
            label: "Semaine"
        },
        days: {
            label: "Jour"
        },
        years: {
            label: "Année"
        }
    }
};